import VendorUtil from '@utils/vendorUtils';
import { OtpRequestPayload, VerifyOtpCodePayload } from '../../models/payload/auth';
import { ropoloRequest } from '../axios';

const sendCode = async (payload: OtpRequestPayload) => (await ropoloRequest.identityAuthLoginCreate(payload)).data;

const verifyCode = async (payload: VerifyOtpCodePayload) =>
  (
    await ropoloRequest.identityAuthVerifyCreate(payload, {
      headers: {
        domain: VendorUtil.getCurrentConfigDomain(),
      },
    })
  ).data;

const logOut = async () => (await ropoloRequest.identityAuthLogoutDelete()).data;

export { sendCode, verifyCode, logOut };
